import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StatsComponent } from '../stats/stats.component'
import { BarPercentComponent } from '../bar-percent/bar-percent.component'
import { StatData } from '../../interfaces/stat.interface'
import { ApiService, UserInfo } from 'app/services/api.service'
import { TranslateModule, TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-stats-benefits',
    standalone: true,
    imports: [CommonModule, StatsComponent, BarPercentComponent,TranslateModule],
    templateUrl: './stats-benefits.component.html',
    styleUrls: ['./stats-benefits.component.scss'],
})
export class StatsBenefitsComponent {
    userInfo: UserInfo
    statsData: StatData[]

    constructor(private api: ApiService, private translate: TranslateService) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
            if (userInfo.loyaltyLevel && userInfo.country)
                this.api.getNextLoyaltyLevelRequirements(userInfo.loyaltyLevel, userInfo.country).subscribe((requirements) => {
                    //modeltypes:
                    // 01: brand presence
                    // 02: global presence
                    // 03 global presence + displays (obsolete)
                    // 04: global presence + cosentino displays (obsolete)
                    //por defecto miramos marca global y cogemos silestone ya que ambas marcas estaran informadas al mismo nivel en mercados con modelo global, esto afecta asi a USA y CA tambien
                    this.statsData = [
                        {
                            current: userInfo.ytdSales || 0,
                            total: requirements.ytdSales,
                            percent: requirements.ytdSales ? ((userInfo.ytdSales || 0) / requirements.ytdSales) * 100 : 0,
                            label: this.translate.instant('benefits_kb.salesYtd'),
                        },
                        {
                            current: userInfo.silestonePresence || 0,
                            // total: requirements.silestonePresence,
                            percent: requirements.silestonePresence ? ((userInfo.silestonePresence || 0) / requirements.silestonePresence) * 100 : 0,
                            label: this.translate.instant('benefits_kb.brand_presence'),
                        },
                    ]
                    //si es modelo 2 y la presencia diferencia entre marcas, añadimos dekton.
                    if (requirements.modelType == '02') {
                        this.statsData[1].label = this.translate.instant('benefits_kb.silestone_presence')
                        this.statsData.push({
                            current: userInfo.dektonPresence || 0,
                            // total: requirements.dektonPresence,
                            percent: requirements.dektonPresence ? ((userInfo.dektonPresence || 0) / requirements.dektonPresence) * 100 : 0,
                            label: this.translate.instant('benefits_kb.dekton_presence'),
                        })
                    }
                })
        })
    }
}
